import { AppContext } from 'mini-app-context';
import { getFilteredUserConfiguration } from 'mini-settings/lib/selectors/getFilteredUserConfiguration';
import { LOCAL_SELECTION_DONE } from 'mini-calendar-utils/lib/eventSignalConstants';
import { mutatorAction } from 'satcheljs';

const updateUserConfigurationCalendarSelection = mutatorAction(
    'updateUserConfigurationCalendarSelection',
    (calendarId: string, isSelected: boolean, ctx?: AppContext) => {
        const userConfig = getFilteredUserConfiguration();
        if (userConfig?.ViewStateConfiguration) {
            const selectedCalendarsTNarrow =
                userConfig.ViewStateConfiguration.SelectedCalendarsTNarrow || [];

            const indexOfCalendar = selectedCalendarsTNarrow.indexOf(calendarId);
            if (isSelected && indexOfCalendar === -1) {
                selectedCalendarsTNarrow.push(calendarId);
            } else if (!isSelected && indexOfCalendar !== -1) {
                selectedCalendarsTNarrow.splice(indexOfCalendar, 1);
            }

            userConfig.ViewStateConfiguration.SelectedCalendarsTNarrow = selectedCalendarsTNarrow;
            ctx?.signal(LOCAL_SELECTION_DONE, { isSelected });
        }
    }
);

export default updateUserConfigurationCalendarSelection;
